import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-oee-state-equipment',
  templateUrl: './oee-state-equipment.component.html',
  styleUrls: ['./oee-state-equipment.component.css']
})
export class OeeStateEquipmentComponent implements OnInit {
    oeeStateEquipmentKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.oeeStateEquipmentKeyno = this.stateService.getStateParams()['oeestate_equipment_keyno'];
    }

    private async loadEdit() {
        if (!!this.oeeStateEquipmentKeyno) {
            this.edit = (await this.datatask.Post(244, { oeestate_equipment_keyno: this.oeeStateEquipmentKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(245, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    oeestate_equipment_keyno: number;
    equipment_name: string;
    oeestate_name: string;
    include: number;
    oeestate_keyno: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateEquipment', {
//        templateUrl: 'views/components/views/oeeStateEquipment/oeeStateEquipment.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'oeeStateEquipmentService', function ($stateParams, stateService, oeeStateEquipmentService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let oeeStateEquipmentKeyno = $stateParams.oeestate_equipment_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await oeeStateEquipmentService.getEdit({ oeestate_equipment_keyno: oeeStateEquipmentKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                oeeStateEquipmentService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
